import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="trip-form"
export default class extends Controller {
    static targets = ['loading']

    connect() {
        this.element.addEventListener('submit', this.handleSubmit.bind(this))
    }

    handleSubmit() {
        this.loadingTarget.classList.remove('d-none')
    }
} 